import React, { useContext, useState } from 'react';
import { ThemeContext } from '../../contexts/ThemeContext';
import { LanguageContext } from '../../contexts/LanguageContext';
import {
  StyledContact,
  ContactContent,
  ContactForm,
  FormGroup,
  ContactInfo,
  InfoItem
} from './styles';
import emailjs from '@emailjs/browser';

const Contact = () => {
  const { theme } = useContext(ThemeContext);
  const { language, translations } = useContext(LanguageContext);

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
    honeypot: ''
  });

const serviceID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
const templateID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

const handleSubmit = (e) => {
  e.preventDefault();

  if (formData.honeypot?.trim() !== '') return;

  const lastEmailTime = localStorage.getItem("lastEmailSent");
  const now = Date.now();
  if (lastEmailTime && now - parseInt(lastEmailTime) < 60 * 60 * 1000) {
    alert("Você já enviou uma mensagem recentemente. Tente novamente mais tarde.");
    return;
  }

  // ✅ AGORA sim, declare primeiro:
  const templateParams = {
    name: formData.name,
    email: formData.email,
    phone: formData.phone,
    message: formData.message,
  };

  emailjs
    .send(serviceID, templateID, templateParams, publicKey)
    .then(() => {
      alert("Mensagem enviada com sucesso!");
      localStorage.setItem("lastEmailSent", now.toString());
      setFormData({
        name: "",
        email: "",
        phone: "",
        message: "",
        honeypot: ""
      });
    })
    .catch((error) => {
      console.error("Erro ao enviar e-mail:", error);
      alert("Erro ao enviar mensagem. Tente novamente mais tarde.");
    });
};

  return (
    <StyledContact id="contato">
      <div className="container">
        <h2 dangerouslySetInnerHTML={{ __html: translations[language].contactTitle }} />
        <ContactContent>
          <ContactForm data-aos="fade-right">
            <form id="contactForm" onSubmit={handleSubmit}>
              <FormGroup>
                <label htmlFor="name">{translations[language].name}</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </FormGroup>
              <FormGroup>
                <label htmlFor="email">{translations[language].email}</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </FormGroup>
              <FormGroup>
                <label htmlFor="phone">{translations[language].phone}</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                />
              </FormGroup>
              <FormGroup>
                <label htmlFor="message">{translations[language].message}</label>
                <textarea
                  id="message"
                  name="message"
                  rows="5"
                  value={formData.message}
                  onChange={handleChange}
                  required
                ></textarea>
              </FormGroup>

              {/* Honeypot para bots */}
              <input
                type="text"
                name="honeypot"
                value={formData.honeypot}
                onChange={handleChange}
                style={{ display: 'none' }}
              />

              <button type="submit" className="btn btn-primary">
                {translations[language].send}
              </button>
            </form>
          </ContactForm>

          <ContactInfo data-aos="fade-left">
            <InfoItem>
              <div className="icon">
                <i className="fab fa-whatsapp"></i>
              </div>
              <div className="text">
                <h3>WhatsApp</h3>
                <p>
                  <a
                    href="https://wa.me/5521969427579"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {translations[language].contactCta}
                  </a>
                </p>
              </div>
            </InfoItem>

            <InfoItem>
              <div className="icon">
                <i className="fas fa-phone-alt"></i>
              </div>
              <div className="text">
                <h3>Telefone</h3>
                <p>(21) 96942-7579</p>
              </div>
            </InfoItem>

            <InfoItem>
              <div className="icon">
                <i className="fas fa-envelope"></i>
              </div>
              <div className="text">
                <h3>E-mail</h3>
                <p>
                  <a href="mailto:atendimento@integrarq.com.br">
                    atendimento@integrarq.com.br
                  </a>
                </p>
              </div>
            </InfoItem>

            <InfoItem>
              <div className="icon">
                <i className="fas fa-map-marker-alt"></i>
              </div>
              <div className="text">
                <h3>{translations[language].addressLabel}</h3>
                <p>Rio de Janeiro, RJ</p>
              </div>
            </InfoItem>
          </ContactInfo>
        </ContactContent>
      </div>
    </StyledContact>
  );
};

export default Contact;
